export enum NotificationType {
  JobOffer = 'job_offer',
  JobOfferAccepted = 'job_offer_accepted',
  JobOfferDeclined = 'job_offer_declined',
  ApplicationSent = 'application_sent',
  ApplicationAccepted = 'application_accepted',
  ApplicationDeclined = 'application_declined',
  NewMessage = 'new_message',
  JobTitlePendingAccepted = 'job_title_pending_accepted',
  JobTitlePendingBlocked = 'job_title_pending_blocked',
}
